import React from 'react'
import PropTypes from 'prop-types'
import DoneAll from '@material-ui/icons/DoneAll'
import LockOpen from '@material-ui/icons/LockOpen'
import Button from 'components/CustomButtons/Button.jsx'
import CustomInputAdornment from 'components/CustomInput/CustomInputAdornment'
import { renderSnackbar } from 'actions/snackbar'
import { connect } from 'react-redux'
import api from 'api'
import validate, { constraints } from 'services/formValidator'
import { parseErrorViolations } from 'services/utils'
import {withStyles} from "@material-ui/core";
import compose from 'recompose/compose';
import stylePlatform from 'assets/css/style.jsx';

const styles = require(`../../assets/css/style.jsx`).default;

const login_constraints = {
  currentPwd: [constraints.isRequired],
  plainPassword: [constraints.isRequired],
  confirmPassword: [constraints.isRepetead('plainPassword')]
}

class ChangePwdForm extends React.Component {
  state = {
    errors: {}
  }

  handleSubmit = e => {
    e.preventDefault()

    const data = {
      currentPwd: e.target.currentPwd.value,
      plainPassword: e.target.plainPassword.value,
      confirmPassword: e.target.confirmPassword.value
    }
    let errors = validate(data, login_constraints)
    if (Object.keys(errors).length === 0) {
      api.user.change_pwd(data)
        .then(resp => {
          this.props.renderSnackbar({
            color: 'success',
            message: 'Votre mot de passe a bien été mis à jour.'
          })
        })
        .catch(error => {
          errors = parseErrorViolations(error)
          this.setState({ errors })
        })
    }
    this.setState({
      errors
    })
  }

  render() {
    const { classes } = this.props;
    const { errors } = this.state;

    return (
      <form className={classes.form} onSubmit={(e) => this.handleSubmit(e)}>
        <CustomInputAdornment
          error={!!errors.currentPwd}
          icon={LockOpen}
          inputProps={{
            placeholder: 'Mot de passe actuel',
            name: 'currentPwd',
            type: 'password',
          }}
        />
        <CustomInputAdornment
          error={!!errors.plainPassword}
          icon={LockOpen}
          inputProps={{
            placeholder: 'Nouveau mot de passe',
            name: 'plainPassword',
            type: 'password'
          }}
        />
        <CustomInputAdornment
          error={!!errors.confirmPassword}
          icon={DoneAll}
          inputProps={{
            placeholder: 'Confirmation nouveau mot de passe',
            name: 'confirmPassword',
            type: 'password'
          }}
        />
        <div className={classes.center}>
            <Button style={styles.btnLogin} type='submit'>
                Enregistrer
            </Button>
        </div>
      </form>
    );
  }
}

ChangePwdForm.propTypes = {
  classes: PropTypes.object.isRequired,
  renderSnackbar: PropTypes.func.isRequired
};
export default compose(connect(null, { renderSnackbar }), withStyles(stylePlatform))(ChangePwdForm)



// WEBPACK FOOTER //
// ./src/views/Forms/ChangePwdForm.jsx